// Constants for storing any current or future integration ids and slugs
export const INTEGRATOR_ID = {
  Intellikids: 'b3ba8372-8153-4fcf-9aeb-c117dd8050ae'
};

export const INTEGRATOR_SLUG = {
  Intellikids: 'intellikids'
};
